<template>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-2">
        <v-layout wrap>
            <v-flex xs12>
                <v-card
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-layout row justify-space-between>
                        <v-layout column class="ma-1 px-3">
                            <v-card-text
                                class="mb-0 pb-0 pt-2 pl-2"
                                v-if="student && student.familyID"
                            >
                                <div
                                    class="display-1 font-weight-bold mb-0 ml-0"
                                >
                                    {{
                                        student.hebName +
                                            " " +
                                            student.lastNameH
                                    }}
                                </div>
                                <div class="ml-0 mt-4">
                                    <div class="pl-3">
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Family ID:
                                            </div>
                                            <div>
                                                {{ student.familyID }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Student ID:
                                            </div>
                                            <div>
                                                {{ student.studentID }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Father:
                                            </div>
                                            <div>
                                                {{ student.hname }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Branch:
                                            </div>
                                            <div>
                                                {{ student.branch }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Grade:
                                            </div>
                                            <div>
                                                {{ student.class }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Section:
                                            </div>
                                            <div>
                                                {{ student.section }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Building:
                                            </div>
                                            <div>
                                                {{ student.building }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Address:
                                            </div>
                                            <div>
                                                {{ student.address1 }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Home Phone:
                                            </div>
                                            <div>
                                                {{ student.homePhone }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Cell Phone:
                                            </div>
                                            <div>
                                                {{ student.cellPhone }}
                                            </div>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="mb-0"
                                            v-if="
                                                allowSpecialNeedsProgramAccess()
                                            "
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                                style="width: 200px;"
                                            >
                                                Special Needs Program:
                                            </div>
                                            <a
                                                @click="
                                                    openSpecialNeedsStudentView()
                                                "
                                                class="spacail-needs-link"
                                                >{{
                                                    student.specialNeedsProgram
                                                        ? "View"
                                                        : "Sign Up"
                                                }}</a
                                            >
                                        </v-layout>

                                        <!-- <v-divider class="pb-2"></v-divider>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Registered:
                                            </div>
                                            <div>
                                                {{
                                                    student.isCampRegistered
                                                        ? "Yes"
                                                        : "No"
                                                }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Pin:
                                            </div>
                                            <div>
                                                {{ student.pin }}
                                            </div>
                                        </v-layout> -->
                                    </div>
                                </div>
                            </v-card-text>
                        </v-layout>
                    </v-layout>

                    <v-spacer></v-spacer>

                    <!-- <v-layout
                        align-end
                        justify-space-between
                        column
                        fill-height
                        class="mb-0 mr-2"
                    >
                        <v-btn
                            class="mt-0 mb-3 mr-1"
                            color="success"
                            small
                            dark
                            @click="openSpecialNeedsStudentView"
                        >
                            Spatial Needs Program
                        </v-btn>
                    </v-layout> -->
                </v-card>
                <v-card
                    class="pa-3 mt-3"
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-tabs color="success" dark icons-and-text>
                        <v-tabs-slider color="#fff"></v-tabs-slider>

                        <v-tab href="#therapy">
                            Therapy
                            <v-icon>mdi-account-edit</v-icon>
                        </v-tab>

                        <v-tab-item value="therapy">
                            <v-btn
                                class="mb-2"
                                small
                                @click="openTherapyDialog"
                                color="success"
                                >Therapy</v-btn
                            >
                            <v-layout
                                row
                                class="px-3 py-2"
                                v-for="prop in getTherapyProperties()"
                            >
                                <div class="font-weight-medium mr-2 width-200">
                                    {{ prop.name }}:
                                </div>
                                <div>
                                    {{ prop.value }}
                                </div>
                            </v-layout>
                            <v-layout
                                row
                                class="px-3 py-2"
                                v-if="
                                    therapyInfoOriginal.id &&
                                        therapyInfoOriginal.updatedOn
                                "
                            >
                                <div class="font-weight-medium mr-2 width-200">
                                    Updated On:
                                </div>
                                <div>
                                    {{ therapyInfoOriginal.updatedOn | time }}
                                </div>
                            </v-layout>
                        </v-tab-item>
                    </v-tabs>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog persistent v-model="updateTherapyDialog" max-width="850">
            <update-therapy-info
                :therapyInfo="therapyInfo"
                :student="student"
                :close="closeTherapyDialog"
            ></update-therapy-info>
        </v-dialog>
    </v-container>
</template>
<script>
import {
    groupBy,
    formatPhoneNumber,
    toTitleCase,
    except,
} from "../../utils/helpers.js";
import moment from "moment";
import updateTherapyInfo from "./UpdateTherapyInfo.vue";

export default {
    components: {
        updateTherapyInfo,
    },
    data: () => ({
        student: null,
        therapyInfo: {
            studentID: "",
            seating: "",
            follwingInstructions: "",
            speaking: "",
            coloring: "",
            counting: "",
            playing: "",
            artsAndCrafts: "",
            alphabet: "",
            walking: "",
            therapy: "",
            otherConcerns: "",
            calledParents: "",
            playingAlone: "",
            playingShtert: "",
        },
        therapyInfoOriginal: "",
        processing: false,
        loadingStudent: true,
        updateTherapyDialog: false,

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    async created() {
        await this.load();
    },
    methods: {
        async load() {
            await this.loadStudent();
        },
        async loadStudent() {
            const student = await this.$http.get(
                "api/students/getStudent?studentID=" + this.$route.params.id
            );

            student.specialNeedsLink = student.specialNeedsProgram
                ? "../special-needs-student-view/" + this.$route.params.id
                : "../special-needs-student-apply/" + this.$route.params.id;

            this.student = student;
            this.loadingStudent = false;

            this.loadTherapyInfo();
        },
        async loadTherapyInfo() {
            const therapyInfo = await this.$http.get(
                "api/studentsTherapy/getForStudent?studentID=" +
                    this.$route.params.id
            );

            if (therapyInfo) {
                this.therapyInfo = therapyInfo;
                this.therapyInfoOriginal = therapyInfo;
            }
        },
        openSpecialNeedsStudentView() {
            this.$router.push({
                name: this.student.specialNeedsProgram
                    ? "SpecialNeedsStudentView"
                    : "SpecialNeedsStudentApply",
                params: { id: this.$route.params.id },
            });
        },
        allowSpecialNeedsProgramAccess() {
            if (!this.isProvider() || !this.student.provider) return true;

            return (
                this.$store.state.authentication.user == this.student.provider
            );
        },
        isProvider() {
            const roles = Array.isArray(this.$store.state.authentication.roles)
                ? this.$store.state.authentication.roles
                : this.$store.state.authentication.roles
                ? this.$store.state.authentication.roles.split(",")
                : [];

            return roles.includes("Special Needs Provider");
        },
        openTherapyDialog() {
            this.updateTherapyDialog = true;
        },
        closeTherapyDialog() {
            this.updateTherapyDialog = false;

            this.loadTherapyInfo();
        },
        getTherapyProperties() {
            if (!this.therapyInfoOriginal.id) return;

            return Object.keys(
                except(this.therapyInfoOriginal, "id", "studentID", "updatedOn")
            )
                .map((key) => {
                    return {
                        name: toTitleCase(key),
                        value: this.therapyInfoOriginal[key],
                    };
                })
                .filter((p) => p.value);
        },
    },
};
</script>
<style>
.v-expansion-panel__header {
    height: 63px;
}
.distribution-list {
    border: 1px solid #ddd !important;
}
.spacail-needs-link {
    color: rgb(76, 175, 80);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}
</style>
